import { useMemo } from "react"

import { Psychologist } from "utils/interfaces"
import { applyDiscount } from "modules/discount/discount-utils"

interface DiscountViewData {
    hasDiscount: boolean
    price: [number | undefined, number | undefined]
}

export function useDiscountViewData(
    psy: Psychologist,
    price: number | undefined
): DiscountViewData {
    return useMemo(() => {
        if (!price || !psy.discount) {
            return {
                hasDiscount: false,
                price: [price, undefined],
            }
        }

        const priceWithDiscount = applyDiscount(psy.discount, price)
        const hasDiscount = priceWithDiscount < price

        return {
            hasDiscount,
            price: [price, hasDiscount ? priceWithDiscount : undefined],
        }
    }, [price, psy.discount])
}
